import { isValidGuid } from './geradorGuid';
import { isObjEmpty } from '@app/helpers/objHelper';

export const compareStringWithIncludes = (str: string, search: string): boolean => {
    if (isObjEmpty(str) || isObjEmpty(search)) {
        return false;
    }
    return str.toLowerCase().includes(search.toLowerCase());
};

export const toCamelCase = (str: string) => {
    if (isObjEmpty(str)) {
        return '';
    }
    return str
        .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
        .replace(/\s/g, '')
        .replace(/^(.)/, function ($1) { return $1.toLowerCase(); });
}

export const toUpperCaseFirstChar = (value: string) => {
    return value.slice(0, 1).toUpperCase() + value.slice(1);
}

export const camalize = (value: string) => {
    if (isObjEmpty(value)) {
        return value;
    }

    const words: string = (" " + value);

    if (words.length > 0) {
        const delim: string = ' ';
        return words.split(delim).map(function (v) { return toUpperCaseFirstChar(v) }).join(delim);
    }

    return value;
}

export const convertToSlug = (text: string) => {
    const a = 'àáäâãèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
    const b = 'aaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
    const p = new RegExp(a.split('').join('|'), 'g')
    return text.toString().toLowerCase().trim()
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special chars
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[\s\W-]+/g, '-') // Replace spaces, non-word characters and dashes with a single dash (-)
}

export const compareStringSlug = (str1: string, str2: string): boolean => {
    if (isObjEmpty(str1) || isObjEmpty(str2)) {
        return false;
    }

    let slug1 = convertToSlug(str1)
    let slug2 = convertToSlug(str2);

    return compareStringWithIncludes(slug1, slug2);
}

export const vtExtractGuidString = (value: string, prefix = '', sufix = ''): string => {

    //prefix/GUID/sufix
    const reg = `(?<=${prefix}\/).*(?=\/${sufix})`;
    const guid = value.match(reg);

    if (guid && isValidGuid(guid[0])) {
        return guid[0]
    }

    return "";
}

export const fixedEncodeURIComponent = (str: string) => {
    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
        return '%' + c.charCodeAt(0).toString(16);
    });
}

export const fixedEncodeURI = (str: string) => {
    return encodeURI(str).replace(/%5B/g, '[').replace(/%5D/g, ']');
}

export const removeDuplicates = (str: string) => {
    const arr = str.split("");
    const arr2: string[] = [];

    arr.forEach((el, i) => {
        if (!arr2.includes(el)) {
            arr2.push(el);
        }
    });
    return arr2.join("").replace(",", "").replace("", " ");
};

export function validateEmail(email: string) {
    const res = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return res.test(String(email).toLowerCase());
}

export const isEmptyOrSpaces = (str: string) => {
    return str === null || str.match(/^ *$/) !== null;
};

export const compareStrings = (a: string | number, b: string | number) => {
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
}

export const vtParseBooleanFromString = (value: string): boolean => {
    const lowerValue = value.toLowerCase();

    if (lowerValue === 'true') {
        return true;
    } else if (lowerValue === 'false') {
        return false;
    } else {
        throw new Error(`"${value}" is not a valid boolean string`);
    }
};

export const thousandSeparator = (value: any) => {
    if (!value) {
        return '';
    }
    let [integer, decimal] = String(value).split('.');
    if (!decimal) {
        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return `${integer},00`;
    }
    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (decimal.length === 1) {
        return `${formattedInteger},${decimal}0`;
    }
    if (decimal.length > 2) {
        decimal = parseFloat('0.' + decimal).toFixed(5).slice(0, -3).replaceAll('0.', '')
    }
    return `${formattedInteger},${decimal}`;
};

export const parserCurrency = (number: string | undefined) => {
    if (!number) {
        return '';
    }

    var negative = number.includes('-') ? '-' : '';
    let valor = number.replace(/[^0-9]/gm, '');
    let valorFloat = parseFloat(valor) / 100;
    if (isNaN(valorFloat)) return '0,00';
    return negative + valorFloat.toFixed(2);
};

export const vtMaskToCNPJ = (value: string) => {
    if (!value) {
        return '';
    }
    return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export const vtStringToNumbers = (value: string): string => {
    if (!value) {
        return '';
    }
    return value.replace(/\D/g, "");
}

export const vtStringToBoolean = (stringValue: string): boolean => {
    if (!stringValue) return false;
    switch (stringValue.toLowerCase().trim()) {
        case "true":
        case "yes":
        case "1":
            return true;

        case "false":
        case "no":
        case "0":
        case null:
        case undefined:
            return false;

        default:
            return false;//JSON.parse(stringValue);
    }
}

export const vtStringSetCharAt = (str: string, index: number, chr: string): string => {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
}